import { LegacyDataProviderRowData } from '@adv-frontend/data-provider';
import { BaseRowData } from '../../types';

export function mapSubRows<RowData extends BaseRowData>(subRows: RowData[]): LegacyDataProviderRowData[] {
    return subRows.map(subRow => {
        if (subRow.subRows) {
            return { id: subRow.id, status: 'loaded', subRows: mapSubRows(subRow.subRows) };
        }

        return { id: subRow.id, status: 'loaded' };
    });
}
